__turbopack_context__.v({
  "caption": "connected-answer-module__pObH9a__caption",
  "card": "connected-answer-module__pObH9a__card",
  "cardContent": "connected-answer-module__pObH9a__cardContent",
  "controls": "connected-answer-module__pObH9a__controls",
  "exhibit": "connected-answer-module__pObH9a__exhibit",
  "play": "connected-answer-module__pObH9a__play",
  "shellPrompt": "connected-answer-module__pObH9a__shellPrompt",
  "stack": "connected-answer-module__pObH9a__stack",
  "terminal": "connected-answer-module__pObH9a__terminal",
  "terminalDots": "connected-answer-module__pObH9a__terminalDots",
  "terminalLabel": "connected-answer-module__pObH9a__terminalLabel",
  "terminalNote": "connected-answer-module__pObH9a__terminalNote",
  "terminalRecords": "connected-answer-module__pObH9a__terminalRecords",
});
